var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCrossInRedCircleBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#FF004A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0016 45.9999C20.7218 46.0041 14.157 41.6195 11.3706 34.892C8.58414 28.1646 10.1254 20.4205 15.2751 15.2735C19.8218 10.7254 26.4489 8.94914 32.6598 10.6139C38.8708 12.2786 43.7221 17.1314 45.3863 23.3442C47.0505 29.5571 45.2748 36.1861 40.7281 40.7342C37.3593 44.1193 32.7766 46.0154 28.0016 45.9999ZM13.6092 28.3134C13.6943 36.2338 20.1597 42.5978 28.0781 42.5554C35.9965 42.5126 42.3932 36.0795 42.3932 28.1586C42.3932 20.2377 35.9965 13.8046 28.0781 13.7618C20.1597 13.7195 13.6943 20.0834 13.6092 28.0038V28.3134ZM23.3403 35.2022L20.8054 32.6648L25.4649 28.0038L20.8054 23.3429L23.3421 20.8055L28.0016 25.4664L32.6612 20.8055L35.1978 23.3429L30.5383 28.0038L35.1978 32.6648L32.663 35.2022L28.0016 30.5413L23.3421 35.2022H23.3403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCrossInRedCircleBig);
export default __webpack_public_path__ + "static/media/white-cross-in-red-circle-big.5ec73f8daf180aed1dfcc553a70e4400.svg";
export { ForwardRef as ReactComponent };